import { config } from '../config';

let widgetReady = false;

const getIframeContainer = () => document.getElementById('hubspot-messages-iframe-container');

export const initHubspot = () => {
    const { environment } = config;

    let hubspotId;

    if (environment === 'production') {
        hubspotId = '4892644';
    } else if (environment === 'staging') {
        hubspotId = '49642184';
    }

    // Exit early if the HubSpot script loader is already present in the DOM.
    // This prevents reinitializing the script unnecessarily.
    if (document.getElementById('hs-script-loader')) return;

    window.hsConversationsSettings = {
        loadImmediately: true,
    };

    window.hsConversationsOnReady = [() => {
        widgetReady = true;

        window.HubSpotConversations.on('widgetLoaded', () => {
            const iframeContainer = getIframeContainer();
            if (iframeContainer) {
                iframeContainer.classList.add('invisible');
            }
        });

        window.HubSpotConversations.on('widgetClosed', () => {
            const iframeContainer = getIframeContainer();
            if (iframeContainer) {
                iframeContainer.classList.add('invisible');
            }
        });
    }];

    const script = document.createElement('script');
    script.type = 'text/javascript';
    script.id = 'hs-script-loader';
    script.async = true;
    script.defer = true;
    script.src = `//js.hs-scripts.com/${hubspotId}.js`;

    document.head.appendChild(script);
};

export const openHubspotWidget = () => {
    if (widgetReady && window.HubSpotConversations) {
        window.HubSpotConversations.widget.open();
        const iframeContainer = getIframeContainer();
        if (iframeContainer) {
            iframeContainer.classList.remove('invisible');
        }
    } else {
        console.error('Failed to open Hubspot chat widget');
    }
};
